
import { useState } from 'react';
import '../assets/styles/game.css';
import Board from './Board';

const GameScreen = ({names, score, setScore, history, setHistory, setScreen}) => {
  const [currentPlayer, setCurrentPlayer] = useState(0);


  return (
    <div className="game">
      <div className='player'>
        It's {(currentPlayer === 0) ? names.player1 : names.player2}'s turn
      </div>
      <Board names={names} currentPlayer={currentPlayer} setCurrentPlayer={setCurrentPlayer} 
             history={history} setHistory={setHistory} setScreen={setScreen} 
             score={score} setScore={setScore} />
    </div> 
  );
}

export default GameScreen;